import {Grid} from '@mui/material';
import LandingCta from '../landing/LandingCta';
import FeatureList from './FeatureList';

export default function FeaturePage() {
  return (
    <Grid container direction="column" spacing={2}>
      <FeatureList />
      <LandingCta />
    </Grid>
  );
}
